import { ExpandMore, TrendingDown, TrendingUp } from "@mui/icons-material";
import { Box, Checkbox, Chip, Typography } from "@mui/material";

import { AttributeExamples } from "../types";

interface AttributeCardSummaryProps {
  attributeExamples: AttributeExamples;
  isSelected: boolean;
  onSelect: (attribute: string) => void;
  isExpanded: boolean;
  onExpand: (attribute: string | null) => void;
  expandedType: "low" | "high" | null;
  onExampleTypeClick: (type: "low" | "high" | null) => (event: React.MouseEvent) => void;
}

const AttributeCardSummary = ({
  attributeExamples,
  isSelected,
  onSelect,
  isExpanded,
  onExpand,
  expandedType,
  onExampleTypeClick
}: AttributeCardSummaryProps) => {
  const hasNoExamples = attributeExamples.lowScoring.length === 0 && attributeExamples.highScoring.length === 0;

  return (
    <>
      <Checkbox
        checked={isSelected}
        onChange={(e) => {
          e.stopPropagation();
          onSelect(attributeExamples.attribute);
        }}
        disabled={hasNoExamples}
        onClick={(e) => e.stopPropagation()}
      />
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
        <Typography variant="h6">{attributeExamples.attribute}</Typography>
        <Chip
          label={`Avg Score: ${attributeExamples.avgScore.toFixed(2)}`}
          size="small"
          color="primary"
          variant="outlined"
        />
        <Chip label={`${attributeExamples.count} examples`} size="small" variant="outlined" />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 2 }}>
        <Chip
          icon={<TrendingDown />}
          label={`Low-Scoring Examples (${attributeExamples.lowScoring.length})`}
          size="small"
          color={expandedType === "low" ? "error" : "default"}
          variant={expandedType === "low" ? "filled" : "outlined"}
          onClick={onExampleTypeClick("low")}
          disabled={attributeExamples.lowScoring.length === 0}
          sx={{ cursor: "pointer" }}
        />
        <Chip
          icon={<TrendingUp />}
          label={`High-Scoring Examples (${attributeExamples.highScoring.length})`}
          size="small"
          color={expandedType === "high" ? "success" : "default"}
          variant={expandedType === "high" ? "filled" : "outlined"}
          onClick={onExampleTypeClick("high")}
          disabled={attributeExamples.highScoring.length === 0}
          sx={{ cursor: "pointer" }}
        />
        <Box
          onClick={(e) => {
            e.stopPropagation();
            if (isExpanded) {
              onExpand(null);
            }
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s"
          }}
        >
          <ExpandMore />
        </Box>
      </Box>
    </>
  );
};

export default AttributeCardSummary;
